import { configureStore } from '@reduxjs/toolkit'
import authSlice from './slice/authSlice'
import mealSlice from './slice/mealSlice'
import mealPlanDetailReducer from './slice/mealPlanDetailSlice';
import orderReducer from './slice/orderSlice';
import dailyOrdersReducer from './slice/dailyOrdersSlice';
import usersReducer from './slice/UsersSlice'
import statsReducer from './slice/statsSlice'
import orderSettingsReducer from "./slice/orderSettingsSlice";
import userDescriptionsReducer from "./slice/userDescriptionsSlice";


export const store = configureStore({
  reducer: {
    auth: authSlice,
    mealPlanDetails: mealPlanDetailReducer,
    orders: orderReducer,
    dailyOrders: dailyOrdersReducer,
    mealDetails: mealSlice,
    users:usersReducer,
    stats: statsReducer,
    orderSettings: orderSettingsReducer,
    userDescriptions: userDescriptionsReducer, 
  },
})